// extracted by mini-css-extract-plugin
export default {"wrapper":"_2uUNR491QtJQVY8xjYgKC1"};